jQuery(document).ready(function ($) {
    'use strict';

    $( document ).on( 'click', '.faq-headline', function(){
        $(this).toggleClass('active');
        $(this).next().toggle();
    });

    $( document ).on( 'click', '.clear-faq-search', function(){
        $('#faq-search').val('').trigger('input');
    });

    $( document ).on( 'input', '#faq-search', function(e){
        var txt = $(this).val();
        if (e.keyCode == 13) {
            return false;
        }
        if(txt.length >= 2) {
            $('.faq-search-results').html('').show().addClass('loading');
            $('.faq-list').hide();
            $('.clear-faq-search').addClass('visible');
            $.ajax({
                url : "/wp-admin/admin-ajax.php",
                method : "post",
                data : {
                    action: 'faq_search',
                    search: txt
                },
                success: function( data ) {
                    $('.faq-search-results').html(data).removeClass('loading');
                }
            });
        } else {
            $('.faq-search-results').html('').hide().removeClass('loading');
            $('.faq-list').show();
            $('.clear-faq-search').removeClass('visible');
        }
    });

});
